export default class HandleVideoOutSite {
  getMediaType(url) {
    if (!url) {
      return '';
    }

    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      return 'youtube';
    }
    if (url.includes('vimeo.com')) {
      return 'vimeo';
    }
    if (url.endsWith('.mp4')) {
      return 'mp4';
    }
    return '';
  }

  checkHandlePauseVideo(iframe, video) {
    const iframeSrc = iframe.attr('src');
    const videoSrc = video.find('source').attr('src');
    const mediaType = iframeSrc ? this.getMediaType(iframeSrc) : this.getMediaType(videoSrc);
    if (mediaType === 'youtube') {
      iframe[0].contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
          args: [],
        }),
        '*',
      );
    } else if (mediaType === 'vimeo') {
      iframe[0].contentWindow.postMessage({ method: 'pause' }, '*');
    } else if (mediaType === 'mp4') {
      video[0].pause();
    } else {
      // do nothing
    }

  }

  checkHandlePlayVideo(iframe, video) {
    const iframeSrc = iframe.attr('src');
    const videoSrc = video.find('source').attr('src');

    const mediaType = iframeSrc ? this.getMediaType(iframeSrc) : this.getMediaType(videoSrc);
    if (mediaType === 'youtube') {
      iframe[0].contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'playVideo',
          args: [],
        }),
        '*',
      );
    } else if (mediaType === 'vimeo') {
      iframe[0].contentWindow.postMessage({ method: 'play' }, '*');
    } else if (mediaType === 'mp4') {
      video[0].play();
    } else {
      // do nothing
    }
  }
}